<template>
  <b-modal
    centered
    id="change-assignee"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Chuyển người làm</h5>
      <b-button size="sm" variant="light" @click="closeModalRequestDevice()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo">
      <div>
        <div class="form-group">
          <label>Từ</label>
          <Select2
            v-model="dataId.currentAssigneeId"
            :options="dataOption"
            disabled
            placeholder="Chọn"
          />
        </div>
        <div class="form-group">
          <label>Đến</label>
          <Select2
            v-model="assigneeIdChangeTo"
            :options="dataOption"
            placeholder="Chọn người tiếp nhận công việc"
          />
        </div>
      </div>
    </form>
    <template #modal-footer>
      <b-button
        class="btn-style"
        size="sm"
        type="button"
        variant="light"
        @click="closeModalRequestDevice()"
      >
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  export default {
    name: 'modal-change-assignee',
    props: {
      dataId: {
        type: Object,
      },
      dataOption: {
        type: Array,
      },
      closeModalRequestDevice: {
        type: Function,
      },
    },
    data() {
      return {
        Config,
        showLoading: false,
        assigneeIdChangeTo: '',
      }
    },
    methods: {
      async updateInfo() {
        const data = this.dataId.data.map(s => ({
          ...s,
          assigneeIdChangeTo: this.assigneeIdChangeTo,
          currentAssigneeId: this.dataId.currentAssigneeId,
        }))
        this.$emit('updateInfo', data)
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
